const deps = [require('data/service/notifications').name, require('ui/web/datePickingModal').name];

const factory = (
  $anchorScroll,
  $location,
  $state,
  $window,
  blConfirmService,
  NotificationsService,
) => {
  const displayErrorMessage = connectionUri => {
    const errorMessage = 'We had trouble establishing a connection with your Square account.';

    return NotificationsService.add(errorMessage, {
      type: 'error',
      length: 10,
      action: () => {
        $window.location.assign(connectionUri);
      },
      actionText: 'Try Connecting Again',
    });
  };

  const goToConnections = () =>
    $state.go(
      'cwa.accounts.connections',
      {},
      {
        reload: true,
      },
    );

  const scrollToAccounts = hashSectionName => {
    $location.hash(hashSectionName);
    $anchorScroll();
  };

  const connectAccount = (onAuthoriseConnection, connectionUri, hashSectionName) =>
    NotificationsService.loader({
      resolve: onAuthoriseConnection(),
      loadingText: 'Completing connection...',
      successText: 'Done.',
      failureText: 'Failed to connect.',
    })
      .then(() => {
        goToConnections().then(scrollToAccounts(hashSectionName));
      })
      .catch(error => displayErrorMessage(connectionUri)); // eslint-disable-line no-unused-vars

  const disconnectAccount = (onDisconnect, serviceName) =>
    NotificationsService.loader({
      resolve: onDisconnect(),
      loadingText: 'Disconnecting...',
      successText: `${serviceName} account disconnected.`,
      failureText: `${serviceName} account could not be disconnected.`,
    });

  const displaySyncMessage = () => {
    const successMessage =
      'Your file is exporting. This may take several minutes. When it ' +
      'is complete, you will receive a notification to download the file from Excel Documents';

    blConfirmService.openConfirm(successMessage, '', '', '', 'OK', '', false);
  };

  const service = {
    connectAccount,
    disconnectAccount,
    displayErrorMessage,
    displaySyncMessage,
    goToConnections,
    scrollToAccounts,
  };

  return service;
};

module.exports = angular
  .module('bench.service.accountService', deps)
  .factory('AccountService', factory);
